import React from 'react';
import { WingBlank, Flex } from 'antd-mobile';
import styles from './WechatLogin.module.scss';
import { ConnectProps } from '@/react-app-env';
import { WECHAT_WEB_APPID } from '@/model/constant';
import qs from 'qs';

const WechatLogin = ({ history }: ConnectProps) => {

  const buildUri = (): string => {
    const data = {
      appid: WECHAT_WEB_APPID,
      redirect_uri: window.location.origin + '/redirect',
      response_type: 'code',
      scope: 'snsapi_login',
      state: 'wechatlogin_web',
    };
    return 'https://open.weixin.qq.com/connect/qrconnect?' + qs.stringify(data) + '#wechat_redirect';
  }

  return (
    <WingBlank size='md'>
      <div className='text-right mt20'>
        <img onClick={() => history.goBack()} className={styles.close_img} src="/images/login_ico_Close@2x.png" alt="" />
      </div>
      <div className='text-center mt20 mb30'>
        <img className='mt20' width='30%' src="/images/login_ico_logo@2x.png" alt="" />
      </div>
      <Flex justify='center'>
        <iframe
          className={styles.qrcode}
          src={buildUri()}
          title="微信扫码登录"
          scrolling="no"
          frameBorder="0"
        />
      </Flex>
    </WingBlank>
  );
}

export default WechatLogin;
